import { v4 } from '@lukeed/uuid';
import { xyIntegration } from 'ml-spectra-processing';
import { DatumKind } from '../../../constants/SignalsKinds';
import { signalMultiplicityPattern } from '../../../signal/signalMultiplicityPattern';
import { getShiftX } from './getShiftX';
import { getSpectrumErrorValue } from './getSpectrumErrorValue';
function checkRange(range, spectrum, error) {
    // check if the range is already exists
    for (const { from, to } of spectrum.ranges?.values || []) {
        if (Math.abs(range.from - from) < error &&
            Math.abs(range.to - to) < error) {
            return true;
        }
    }
}
function getRange(range, shiftTarget, shift) {
    const { originFrom, originTo, from, to } = range;
    if (shiftTarget === 'origin') {
        return {
            originFrom: from - shift,
            originTo: to - shift,
            from,
            to,
        };
    }
    else {
        return {
            originFrom,
            originTo,
            from: (originFrom || 0) + shift,
            to: (originTo || 0) + shift,
        };
    }
}
function getSignalDelta(signal, shiftTarget, shift) {
    const { delta, originDelta } = signal;
    if (shiftTarget === 'origin') {
        return {
            originDelta: delta - shift,
            delta,
        };
    }
    else {
        return {
            originDelta,
            delta: (originDelta || 0) + shift,
        };
    }
}
function nmrRangeToRange(range) {
    const { signals = [], integration = 0, ...restRange } = range;
    const newSignals = [];
    for (const signal of signals) {
        const { multiplicity, ...restSignal } = signal;
        newSignals.push({
            id: v4(),
            js: [],
            multiplicity: multiplicity || signalMultiplicityPattern(signal),
            ...restSignal,
        });
    }
    return {
        id: v4(),
        integration,
        absolute: integration || 0,
        signals: newSignals,
        ...restRange,
    };
}
export function mapRanges(ranges, spectrum, options = {}) {
    const { checkIsExisting = true, shiftTarget = 'origin' } = options;
    const { x, re } = spectrum.data;
    const shiftX = getShiftX(spectrum);
    const error = getSpectrumErrorValue(spectrum);
    let newRanges = ranges.map(nmrRangeToRange);
    if (checkIsExisting) {
        newRanges = newRanges.filter((r) => (checkIsExisting && !checkRange(r, spectrum, error)) || r.id === 'new');
    }
    return newRanges.map((range) => {
        const rangeBoundary = getRange(range, shiftTarget, shiftX);
        const absolute = xyIntegration({ x, y: re }, { from: rangeBoundary.from, to: rangeBoundary.to, reverse: true });
        const signals = range.signals.map((signal) => {
            const { kind = null, id, ...resSignal } = signal;
            return {
                kind: kind || 'signal',
                id: id || v4(),
                ...resSignal,
                ...getSignalDelta(signal, shiftTarget, shiftX),
            };
        });
        return {
            ...range,
            id: range.id || v4(),
            kind: signals?.[0].kind || DatumKind.signal,
            ...rangeBoundary,
            absolute,
            signals,
        };
    });
}
//# sourceMappingURL=mapRanges.js.map